
























import { Component, Vue } from 'vue-property-decorator';

import flagKeys from '@/constants/flagKeys';

import segmentIo from '@/utils/segment.io';

import CheckIcon from '@/components/icons/CheckBig.vue';
import ClockSolidIcon from '@/components/icons/ClockSolid.vue';
import TwismLogoIcon from '@/components/icons/TwismLogo.vue';

import { isExternalOauthSessionOnline } from '@/router/router-utils';

@Component({
  components: {
    CheckIcon,
    ClockSolidIcon,
    TwismLogoIcon
  }
})
export default class WaitingForApproval extends Vue {
  get tPrefix() {
    return 'businessSignup.success';
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get email() {
    const extraInfo = this.$store.getters['manager/getExtraInfo'];
    return (extraInfo && extraInfo.mail) || '';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  created() {
    segmentIo.page('NPO Sign Up/Existing Address Wait for CX', {
      'Signup Online': !!isExternalOauthSessionOnline()
    });
  }
}
